import { Button, Dialog, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface AssetStateUpdateProps {
  restrictStatusChangeToGroundedOnly: boolean;
  state: string;
  onClickStatusUpdateForCraft: (assetID: number, assetState: string, assetStateChangeReason: string) => void;
  assetId: number;
}

const allowedAssetStates = {
  VOLUME_TESTING: 'VOLUME_TESTING',
  LIVE_OPS: 'LIVE_OPS',
  MFG_BUILD: 'MFG_BUILD',
  QC: 'QC',
  WEEKLY_INSPECTION: 'WEEKLY_INSPECTION',
  MONTHLY_INSPECTION: 'MONTHLY_INSPECTION',
  UNSCHEDULED_MAINTENANCE: 'UNSCHEDULED_MAINTENANCE',
  RETIRED: 'RETIRED',
  DEV: 'DEV',
  GROUNDED: 'GROUNDED'
};

const AssetStateUpdate = React.forwardRef((props: AssetStateUpdateProps, ref) => {
  const [openStateModal, setOpenStateModal] = useState(false);
  const handleOpenStateModal = () => setOpenStateModal(true);
  const handleCloseStateModal = () => setOpenStateModal(false);
  const [assetState, setAssetState] = useState('');
  const [assetStateChangeReason, setAssetStateChangeReason] = useState('');
  const [stateHasChanged, setStateHasChanged] = useState(false);

  useEffect(() => {
    if (props.state !== null) {
      setAssetState(props.state);
    }
  }, [props.state]);

  function handleStateChange(newState: string) {
    if (newState !== assetState) {
      setStateHasChanged(true);
    }
    setAssetState(newState);
  }

  function onUpdateButtonClicked() {
    const newState = props.restrictStatusChangeToGroundedOnly ? allowedAssetStates.GROUNDED : assetState;
    props.onClickStatusUpdateForCraft(props.assetId, newState, assetStateChangeReason);
    setStateHasChanged(false);
    handleCloseStateModal();
  }

  return (
    <>
      <Button onClick={handleOpenStateModal} color={props.restrictStatusChangeToGroundedOnly ? 'error' : 'secondary'} size="small" variant="contained">
        {props.restrictStatusChangeToGroundedOnly ? 'Ground aircraft' : 'Update status'}
      </Button>
      <Dialog
        onClose={handleCloseStateModal}
        open={openStateModal}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
        PaperProps={{
          style: {
            margin: '10px 0px',
            width: '100%',
            maxWidth: 500,
            height: '90%',
            maxHeight: 700
          },
        }}
      >
        <DialogTitle>{props.restrictStatusChangeToGroundedOnly ? 'Ground aircraft' : 'Update state'}</DialogTitle>
        <div style={{ padding: 12 }}>
          <FormControl fullWidth>
            {props.restrictStatusChangeToGroundedOnly ? null : (
              <>
                <InputLabel id="state-select-label">State</InputLabel>
                <Select
                  labelId="state-select-label"
                  value={assetState}
                  label="State"
                  onChange={e => handleStateChange(e.target.value)}
                >
                  {Object.keys(allowedAssetStates).map(stateName => (
                    <MenuItem key={`${props.assetId}-${stateName}`} value={stateName}>
                      {allowedAssetStates[stateName]}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}
            <TextField
              style={{ marginTop: 6 }}
              label={props.restrictStatusChangeToGroundedOnly ? 'Reason for grounding' : 'State change reason'}
              variant="standard"
              value={assetStateChangeReason}
              onChange={e => setAssetStateChangeReason(e.target.value)}
            />
          </FormControl>
        </div>
        <div style={{ padding: 12 }}>
          <Button
            onClick={onUpdateButtonClicked}
            color="secondary"
            size="small"
            variant="contained"
            disabled={!stateHasChanged && !props.restrictStatusChangeToGroundedOnly}
          >
            Submit
          </Button>
        </div>
      </Dialog>
    </>
  );
});

export default AssetStateUpdate;
